/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShopifyCommoditySyncStatus
 */
export interface ShopifyCommoditySyncStatus {
    /**
     * True when the company has a linked + enabled Shopify store.
     * @type {boolean}
     * @memberof ShopifyCommoditySyncStatus
     */
    connected: boolean;
}

/**
 * Check if a given object implements the ShopifyCommoditySyncStatus interface.
 */
export function instanceOfShopifyCommoditySyncStatus(value: object): value is ShopifyCommoditySyncStatus {
    if (!('connected' in value) || value['connected'] === undefined) return false;
    return true;
}

export function ShopifyCommoditySyncStatusFromJSON(json: any): ShopifyCommoditySyncStatus {
    return ShopifyCommoditySyncStatusFromJSONTyped(json, false);
}

export function ShopifyCommoditySyncStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShopifyCommoditySyncStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'connected': json['connected'],
    };
}

  export function ShopifyCommoditySyncStatusToJSON(json: any): ShopifyCommoditySyncStatus {
      return ShopifyCommoditySyncStatusToJSONTyped(json, false);
  }

  export function ShopifyCommoditySyncStatusToJSONTyped(value?: ShopifyCommoditySyncStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'connected': value['connected'],
    };
}

